import { ApiGetUsersFilter, ApiGetUsersResponse } from "@incendium/api";
import { useSelectedProject } from "Hooks";
import { getAnalytisUsers } from "features/leadAnalytics";
import { useCallback, useState } from "react";
import { useDebounce } from "react-use";
import useAppendSearchState from "Hooks/useAppendSearchState";

const queryParamUserDashFilters = "ud-f";
const pageSize = 20;

const useLeadAnalyticsData = (pageToken: string) => {
  const { selectedProject } = useSelectedProject();
  const [chartData, setChartData] = useState<ApiGetUsersResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(undefined);
  const [search, setSearch] = useState<string>("");
  const [filters, setFilters] = useAppendSearchState<ApiGetUsersFilter[]>(
    queryParamUserDashFilters,
    [],
  );
  const [leadIds, setLeadIds] = useState<number[]>([]);
  const loadData = useCallback(
    async (
      projectId: number,
      pageToken: string,
      filters?: ApiGetUsersFilter[],
      search?: string,
      leadIds?: number[],
    ) => {
      setLoading(true);
      setError(undefined);

      try {
        const res = await getAnalytisUsers(
          projectId,
          pageSize,
          pageToken,
          filters,
          search,
          leadIds,
        );

        setChartData(res);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  useDebounce(
    () => {
      if (!selectedProject?.id) {
        return;
      }
      loadData(selectedProject.id, pageToken, filters || [], search, leadIds);
    },
    300,
    [selectedProject?.id, search, loadData, filters, pageToken],
  );

  return {
    chartData,
    loading,
    error,
    search,
    setSearch,
    filters,
    setFilters,
    leadIds,
    setLeadIds,
  };
};

export default useLeadAnalyticsData;
